// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Text } from 'informed';

import {
  addHospitalizationHistory,
  deleteHospitalizationHistory,
  updateHospitalizationHistory,
} from '../../../actions/informationHistoryActions';

import DateText from '../../DateText.jsx';
import Table from '../../Table.jsx';
import Typeahead from '../../Typeahead.jsx';

type Props = {
  hospitalizationHistory: Object[],
  activePatientId: string,
  addHospitalizationHistory: Function,
  deleteHospitalizationHistory: Function,
  updateHospitalizationHistory: Function,
}

class HospitalizationHistoryComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.admissionDate = moment(formValues.admissionDate, 'DD-MM-YYYY').toISOString();
    formValues.dischargeDate = moment(formValues.dischargeDate, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    this.props.deleteHospitalizationHistory(this.props.activePatientId, id);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateHospitalizationHistory(this.props.activePatientId, {
      hospitalizationHistoryId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    this.props.addHospitalizationHistory(this.props.activePatientId, formData.values);
  }

  render() {
    const columns = [
      {
        Header: 'Date of Admission',
        id: 'admissionDate',
        cell: item => (item.admissionDate ? moment(item.admissionDate).format() : '--'),
        editCell: item => <DateText field='admissionDate' item={item} />,
        width: 130,
      },
      {
        Header: 'Date of Discharge',
        id: 'dischargeDate',
        cell: item => (item.dischargeDate ? moment(item.dischargeDate).format() : '(ongoing)'),
        editCell: item => <DateText field='dischargeDate' item={item} nullable />,
        width: 130,
      },
      {
        Header: 'Location',
        id: 'location',
        editCell: item => <Typeahead field='location' initialValue={item.location} endpoint='hospHxLocation' />,
      },
      {
        Header: 'Diagnosis',
        id: 'diagnosis',
        editCell: item => <Typeahead field='diagnosis' initialValue={item.diagnosis} endpoint='diagnosis' />,
      },
      {
        Header: 'Treatment at Hospital',
        id: 'hospitalTreatment',
        editCell: item => <Text field='hospitalTreatment' initialValue={item.hospitalTreatment} />,
      },
      {
        Header: 'Discharge Instructions',
        id: 'dischargeInstructions',
        editCell: item => <Text field='dischargeInstructions' initialValue={item.dischargeInstructions} />,
      },
    ];

    return (
      <Table
        columns={columns}
        data={this.props.hospitalizationHistory}
        handleDeleteRow={this.handleDeleteRow}
        handleSaveRow={this.handleSaveRow}
        handleSaveNewRow={this.handleSaveNewRow}
      />
    );
  }
}

const mapStateToProps = state => ({
  hospitalizationHistory: state.patient.data.hospitalizationHistory,
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addHospitalizationHistory: (patientId, hospitalizationHistory) => dispatch(
    addHospitalizationHistory(patientId, hospitalizationHistory),
  ),
  deleteHospitalizationHistory: (patientId, hospitalizationHistoryId) => dispatch(
    deleteHospitalizationHistory(patientId, hospitalizationHistoryId),
  ),
  updateHospitalizationHistory: (patientId, hospitalizationHistory) => dispatch(
    updateHospitalizationHistory(patientId, hospitalizationHistory),
  ),
});

const HospitalizationHistory = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HospitalizationHistoryComponent);

export default HospitalizationHistory;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/informationHistory/HospitalizationHistory.jsx